import React, { useState } from "react";
import SliderDataService from "../../services/SliderService";


const AddSlider = () => {
  const initialSliderState = {
    id: null,
    name: "",
    label: "",
    image:null,
    alt: "",
    published: false
  };
  const [slider, setSlider] = useState(initialSliderState);
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState(" ");

  const handleInputChange = e => {
    const { name, value } = e.target;
    setSlider({ ...slider, [name]: value });
  };

  const handleImageInputChange = e => {
    const { name, value } = e.target;
    const inputimage=e.target.files[0];
    setSlider({ ...slider, [name]: inputimage });
  };

  const saveSlider = () => {
    var data = {
      name: slider.name,
    label: slider.label,
    image: slider.image,
    alt: slider.alt,
    };

    SliderDataService.create(data)
      .then(response => {
        setSlider({
          id: response.data.id,
          name: response.data.name,
    label: response.data.label,
    image: response.data.image,
    alt: response.data.alt,
          published: response.data.published
        });
        setSubmitted(true);
        setServermessage("You have successfully submited!")
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const newSlider = () => {
    setSlider(initialSliderState);
    setSubmitted(false);
  };

  return (
   
    <div className="container pb-10">
     
     
    <h1 className="text-1xl lg:text-1xl font-semibold py-10"> Add Home Slider</h1>
    <div>
    {submitted?(<div className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"   role="alert">
            <p style={{marginBottom: "0"}} >{servermessage}</p>
    </div>):(<><p style={{marginBottom: "0"}} ></p>
    </>)}
     <br></br>
     </div>
       
          <form className="w-full">

          <div className="md:flex md:items-center mb-6">
  <div className="md:w-1/3">
    <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" htmlFor="inline-full-name">
      Name
    </label>
  </div>
  <div className="md:w-2/3">
    <input className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="name" name="name" type="text" value={slider.name} 
     
            required
             
            onChange={handleInputChange}
            />
  </div>
</div>


<div className="md:flex md:items-center mb-6">
  <div className="md:w-1/3">
    <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" htmlFor="inline-full-name">
     Description
    </label>
  </div>
  <div className="md:w-2/3">
    <input className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="label" name="label" type="text" value={slider.link} 
     
            required
             
            onChange={handleInputChange}
            />
  </div>
</div>



<div className="md:flex md:items-center mb-6">
          <div className="md:w-1/3">
            <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"  >
              Image
            </label>
          </div>
          <div className="md:w-2/3">
            <input className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"  type="file"
                    id="image"
                    onChange={handleImageInputChange}
                    name="image"
                    />
          </div>
        </div>





     

         
      </form>


      <div className="md:flex md:items-center">
  <div className="md:w-1/3">
  
</div>
  <div className="md:w-2/3 grid grid-cols-2 gap-40">
   


  {submitted ? (
      <div>
    
         
<button className="shadow bg-green-800 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"  
        type="submit" onClick={newSlider}>
          Add New
        </button>
      </div>
    ) : (
      <>
     <button className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"  
        type="submit" onClick={saveSlider}  >
          Submit
        </button>
      </>
    )}

      


  </div>
</div>

</div>
  );
};
export default AddSlider;